<template>
    <div class="tabs-menu-wrapper">
        <div class="selector">
            <div
                class="tabs-menu-header"
                :class="{ 'header-close': isMenuOpen }"
                @click="switchMenu"
            >
                <div class="title">{{ slotsHeaders[activeField].title }}</div>
                <div class="angle" :class="{ close: isMenuOpen }">
                    <font-awesome-icon
                        class="icon"
                        icon="angle-down"
                    ></font-awesome-icon>
                </div>
                <!--            <div class="close" v-if="isMenuOpen">Закрыть</div>-->
            </div>
            <div class="tabs-menu" v-if="isMenuOpen">
                <div
                    class="tab"
                    v-for="(item, index) in slotsHeaders"
                    :key="index"
                    @click="changeField(index)"
                >
                    <div
                        class="tab-wrapper"
                        :class="{ active: index == activeField }"
                    >
                        {{ item.title }}
                        <div class="bullet" v-if="item.bullet">
                            {{ item.bullet }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div v-if="isMobile" class="tab-divider"></div> -->
        <div class="tab-content" v-if="Object.keys(this.$slots).length > 0">
            <slot :name="currentSlot"></slot>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
const getters = ['isMobile'];

export default {
    name: 'TabsSelector',
    data: () => ({
        isMenuOpen: false,
    }),
    props: {
        activeField: Number,
        slotsHeaders: Array,
    },
    computed: {
        ...mapGetters(getters),
        currentSlot() {
            return Object.keys(this.$slots)[this.activeField];
        },
    },
    methods: {
        switchMenu() {
            this.isMenuOpen = !this.isMenuOpen;
        },
        changeField(index) {
            this.$emit('change-field', index);
            this.switchMenu();
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/mrem';
/*activate checkbox regExp in finder of phpStorm*/
/*find      {: ([0-9]*)px}*/
/*replace   {: rem($1);}*/

$tamH: mrem(100);

@mixin custom-scroll-bar {
    &::-webkit-scrollbar {
        height: auto;
        width: 0.3rem;
    }

    &::-webkit-scrollbar-thumb {
        background: #e1e1e1;
        border-radius: 0.3rem;
    }

    &::-webkit-scrollbar-track {
        background: none;
    }
}

.tabs-menu-wrapper {
    position: relative;
    width: 100%;

    .selector {
        margin: 0;
        padding: 0 mrem(16) mrem(24) mrem(16);
        border-bottom: 1px solid #d2d5d9;
        background-color: #f5f9fc;
        font-family: 'Montserrat', sans-serif;

        .tabs-menu-header {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: mrem(40);
            border: mrem(1) solid #4663ab;
            border-radius: mrem(4);
            box-shadow: 0 0.5rem 0.5rem rgba(155, 161, 166, 0.23626);
            /*position: fixed;*/
            /*z-index: 0;*/
            .title {
                font-size: mrem(14);
                font-weight: 600;
                color: #4663ab;
            }
            .angle {
                display: flex;
                align-items: center;
                justify-content: flex-start;
                font-size: 5rem;
                font-weight: 600;
                margin-left: mrem(5);
                .icon * {
                    color: #4663ab;
                }
            }
            .close {
                transform: rotate(180deg);
            }
        }
        .header-close {
            background: #4663ab;
            .title {
                color: white;
            }
            .angle {
                .icon * {
                    color: white;
                }
            }
        }

        .tabs-menu {
            cursor: pointer;
            width: calc(100% - 8rem);
            border: mrem(1) solid #4663ab;
            position: absolute;
            top: mrem(37);
            z-index: 999;
            background: white;
            padding-top: 2rem;
            padding-bottom: 2rem;

            .tab {
                font-size: 4rem;
                height: mrem(40);
                font-weight: 600;
                padding-left: 7rem;
                padding-right: 7rem;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                color: #4663ab;
                position: relative;

                .tab-wrapper {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    color: black;
                    padding: 2rem 4rem;
                    font-size: mrem(14);
                    width: 100%;
                    &.active {
                        color: #4663ab;
                    }
                }

                .bullet {
                    position: absolute;
                    z-index: 10;
                    width: 1.2rem;
                    height: 1.2rem;
                    font-size: 0.6rem;
                    color: white;
                    background: #ef627d;
                    border-radius: 50%;
                    top: -0.6rem;
                    right: -0.6rem;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 0 rem(1) rem(1) rgba(155, 161, 166, 0.23626);
                }
            }
        }
    }

    .tab-divider {
        position: relative;
        width: 100%;
        height: mrem(1);
        margin-top: mrem(24);
        background: #d2d5d9;

        &::before {
            content: '';
            position: absolute;
            left: mrem(-16);
            width: mrem(16);
            height: mrem(1);
            background: #d2d5d9;
        }

        &::after {
            content: '';
            position: absolute;
            right: mrem(-16);
            width: mrem(16);
            height: mrem(1);
            background: #d2d5d9;
        }
    }

    .tab-content {
        @include custom-scroll-bar;
        bottom: 0;
        left: 0;
        /*background: white;*/
        width: 100%;
        overflow-x: scroll;
    }
}

@import '../../styles/variables';

@media (max-width: $vm) {
    .tabs-menu-wrapper .tab-content {
        overflow-x: unset;
    }
}
</style>
